module.exports = __webpack_public_path__ + "img/features-1.46dcc35.png";